// Exports
export default {
	"newUiWrapper": "newUiWrapper_ZtZw8",
	"badge": "badge_5BXGM"
};
